import React from 'react';
import { motion } from 'framer-motion';
import { Camera, X, Check } from 'lucide-react';
interface PhotoUploadProps {
  photo: string | null;
  onPhotoChange: (photo: string) => void;
  required?: boolean;
}
export function PhotoUpload({
  photo,
  onPhotoChange,
  required = false
}: PhotoUploadProps) {
  const handleAddPhoto = () => {
    // Simulate photo capture (in real app, would open camera)
    const mockPhotoUrl = `https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=600&q=80&sig=${Date.now()}`;
    onPhotoChange(mockPhotoUrl);
  };
  const handleRemovePhoto = () => {
    onPhotoChange('');
  };
  return <div className="space-y-3" data-id="element-182">
      {!photo ? <motion.button type="button" onClick={handleAddPhoto} whileHover={{
      scale: 1.01
    }} whileTap={{
      scale: 0.98
    }} className="w-full aspect-[16/9] border-2 border-dashed border-gray-300 rounded-xl hover:border-teal-deep hover:bg-teal-50/30 transition-all flex flex-col items-center justify-center gap-4 group touch-manipulation" data-id="element-183">
          <div className="w-20 h-20 rounded-full bg-gray-100 group-hover:bg-teal-100 flex items-center justify-center transition-colors" data-id="element-184">
            <Camera className="w-10 h-10 text-gray-400 group-hover:text-teal-deep transition-colors" data-id="element-185" />
          </div>
          <div className="text-center" data-id="element-186">
            <span className="block text-lg font-semibold text-gray-700 group-hover:text-teal-deep transition-colors mb-1" data-id="element-187">
              Scatta Foto Finale
            </span>
            <span className="text-sm text-gray-500" data-id="element-188">
              Documenta il risultato dell'intervento
            </span>
          </div>
        </motion.button> : <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="relative aspect-[16/9] rounded-xl overflow-hidden border-2 border-teal-deep shadow-md group" data-id="element-189">
          <img src={photo} alt="Foto finale" className="w-full h-full object-cover" data-id="element-190" />

          {/* Success Badge */}
          <div className="absolute top-3 right-3 bg-teal-deep text-white p-2.5 rounded-full shadow-lg" data-id="element-191">
            <Check className="w-6 h-6" data-id="element-192" />
          </div>

          {/* Remove Button */}
          <button type="button" onClick={handleRemovePhoto} className="absolute top-3 left-3 w-10 h-10 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-lg touch-manipulation" data-id="element-193">
            <X className="w-5 h-5" data-id="element-194" />
          </button>

          {/* Overlay on hover */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors pointer-events-none" data-id="element-195" />
        </motion.div>}

      {/* Helper text */}
      <p className="text-sm text-gray-500 text-center" data-id="element-196">
        {photo ? '✓ Foto caricata con successo' : required ? 'Foto richiesta' : 'Opzionale'}
      </p>
    </div>;
}